import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReact,  } from '@fortawesome/free-brands-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

const labelsFirst = [
  "React",
  "Node.js",
  "JavaScript",
  "HTML5",
  "CSS3",
  "Tailwind css",
  "Postman",
  "GitHub"
];
const labelssecond = [
    "MySQL",
    "MongoDB",
    "firebase",
  ];
  


function Expertise() {
  return (
    <div className="container" id="expertise">
      <div className="skills-container">
        <h1>Expertise</h1>
        <div className="skills-grid">

          {/* Full Stack */}
          <div className="skill">
            <FontAwesomeIcon icon={faReact} size="3x" />
            <h3>Full Stack Web Development</h3>
            <p>
              I have built a diverse array of web applications from scratch using modern technologies
              such as React and Node js. I have a strong proficiency in the SDLC process and frontend + backend development.
            </p>
            <div className="flex-chips">
              <span className="chip-title">Tech stack:</span>
              {labelsFirst.map((label, index) => (
                <Chip key={index} className='chip' label={label} />
              ))}
            </div>
            <div className="flex-chips">
              <span className="chip-title">Data Base:</span>
              {labelssecond.map((label, index) => (
                <Chip key={index} className='chip' label={label} />
              ))}
            </div>
          </div>

          

        </div>
      </div>
    </div>
  );
}

export default Expertise;
